import type {
  PartnerContact,
  PartnerContactCreate,
  PartnerContactUpdate,
  PartnerSearchContactsParams,
} from '@shipium-corp/shipium-ts-types';
import GatewayAxiosClient from '~/store/services/GatewayAxiosClient';

export const contacts = {
  search: {
    queryKey: 'partner-management-service/contacts',
    configurationType: 'default' as const,
    fn: async (params: PartnerSearchContactsParams = {}) => {
      const { data } = await GatewayAxiosClient.get<PartnerContact[]>(
        '/partner-management-proxy/api/v1/partners/contacts',
        {
          params,
        },
      );

      return data;
    },
  },
  get: {
    queryKey: 'partner-management-service/contacts/id',
    configurationType: 'no-cache' as const,
    fn: async (contactId: string) => {
      const { data } = await GatewayAxiosClient.get<PartnerContact>(
        `/partner-management-proxy/api/v1/partners/contacts/${contactId}`,
      );

      return data;
    },
  },
  create: async (contactCreate: PartnerContactCreate) => {
    const { data } = await GatewayAxiosClient.post<PartnerContact>(
      `/partner-management-proxy/api/v1/partners/contacts`,
      contactCreate,
    );

    return { data, invalidateQueryKeys: [['partner-management-service/contacts']] };
  },
  update: async ({ contactId, payload }: { contactId: string; payload: PartnerContactUpdate }) => {
    const { data } = await GatewayAxiosClient.put<PartnerContact>(
      `/partner-management-proxy/api/v1/partners/contacts/${contactId}`,
      payload,
    );

    return {
      data,
      invalidateQueryKeys: [
        ['partner-management-service/contacts'],
        ['partner-management-service/contacts/id', contactId],
      ],
    };
  },
};
